import request from './http';
/**
 * 留言
 * @param {Object} current 
 * @returns 
 */
export const leaveMessages = function (current) {
  return request.post("/zhw/leaveMessages/create", current);
}